export enum SpanName {
  TRACK_ANALYTICS_SNAPCHAT = 'track_analytics_snapchat',
  TRACK_ANALYTICS_BING_ADS = 'track_analytics_bing_ads',
  TRACK_ANALYTICS_FACEBOOK = 'track_analytics_facebook',
  TRACK_ANALYTICS_TABOOLA = 'track_analytics_taboola',
  TRACK_ANALYTICS_AXON = 'track_analytics_axon',
  TRACK_ANALYTICS_PINTEREST = 'track_analytics_pinterest',
  TRACK_ANALYTICS_GTM = 'track_analytics_gtm',
  TRACK_ANALYTICS_TIK_TOK = 'track_analytics_tik_tok',
  TRACK_ANALYTICS_AMPLITUDE = 'track_analytics_amplitude',
  TRACK_ANALYTICS_BACK_END = 'track_analytics_back_end',
  GET_LTV_PREDICT = 'get_ltv_predict',
  RECURRING_PAYMENT_REQUEST = 'recurring_payment_request',
  PAYMENT_METHODS_REQUEST = 'payment_methods_request',
  USER_LOCATION_REQUEST = 'user_location_request',
  CREATE_ASKNEBULA_ACCOUNT = 'create_asknebula_account',
  CREATE_NEBULA_ACCOUNT = 'create_nebula_account',
  AUTHENTICATE_BY_NEBULA_ID = 'authenticate_by_nebula_id',
  PAYMENT_SUCCEED = 'payment_succeed',
  CREATE_ORDER = 'create_order',
  CREATE_NEBULA_APP_LINK = 'create_nebula_app_link',
  WEB2APP_LINK_COPIED = 'web2app_link_copied',
  INITIALIZE_FORM_REQUEST = 'initialize_form_request',
  SCREEN_OPENED = 'screen_opened',
  SCREEN_CLICKED = 'screen_clicked',
  INITIALIZE_RESIGN_FORM = 'initialize_resign_form',
  TRACK_WEB_VITALS = 'track_web_vitals',
  SIGN_IN = 'sign_in',
  TRACK_ANALYTICS_GOOGLE_4 = 'track_analytics_google_4',
  TRACK_ANALYTICS_GOOGLE = 'track_analytics_google',
  SIGN_UP_VIA_GOOGLE = 'sign_up_via_google',
  SIGN_UP_VIA_FACEBOOK = 'sign_up_via_facebook',
  SIGN_UP_VIA_QUIZ = 'sign_up_via_quiz',
  TRACK_ANALYTICS_EVERFLOW_ATTRIBUTION_PARAMETERS = 'track_analytics_everflow_attribution_parameters',
  SSR_PAGE_RENDER = 'ssr_page_render',
  FLOW_RENDER = 'flow_render',
  HTTP_REQUEST = 'http_request',
  CREATE_NATAL_CHART = 'create_natal_chart',
  CREATE_NATAL_CHART_PUBLIC = 'create_natal_chart_public',
  GET_NATAL_CHART_CONTENT = 'get_natal_chart_content',
  ERROR_BOUNDARY = 'error_boundary',
  REVALIDATION = 'revalidation',
  INIT_CACHE_HANDLER = 'init_cache_handler',
  FETCH_ORDER = 'fetch_order',
  DETECT_SCAN = 'detect_scan',
  UPLOAD_SCAN = 'upload_scan',
  REDIS_DISCONNECTED = 'redis_disconnected',
  REDIS_RECONNECTED = 'redis_reconnected',
}
